@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.sectionTitle {
  padding: 6px 8px 2px;
  color: var(--text-subtle);
  @include typography-v2-body-xxs;
  text-transform: uppercase;
}

.avatar {
  width: 16px;
  height: 16px;
  @include border-radius-full;
  flex: none;
}
